import dayjs from 'dayjs'

class Trade {
  constructor(data) {
    const { strike, expiry, put_call, cut } = data

    this['Deal ID'] = data.deal_id
    this['Trade ID'] = data.id
    this['Trade Date'] = dayjs(data.trade_date).format('DDMMYYYY HH:mm:ss')
    this['Type'] = data.type
    this['Counterparty'] = data.client || data.market_maker
    this['Symbol'] = data.symbol
    this['Expiry Date'] = expiry ? dayjs(expiry).format('DDMMYYYY') : ''
    this['Strike Price'] = strike || ''
    this['Put/Call'] = put_call ? put_call[0] : ''
    this['Cut'] = cut || ''
    this['Value Date'] = data.value_date ? dayjs(data.value_date).format('DDMMYYYY') : ''
    this['Quantity'] = data.client_quantity || data.market_maker_quantity || ''
    this['Price'] = data.client_price || data.market_maker_price || ''
    this['Far Quantity'] = data.far_leg_quantity || ''
    this['Far Price'] = data.far_price || ''
    this['Far Value Date'] = data.far_value_date
      ? dayjs(data.far_value_date).format('DDMMYYYY')
      : ''
    this['P&L USD'] = data.pnl_usd_live || ''
    this['Lower Barrier'] = data.lower_barrier || ''
    this['Upper Barrier'] = data.upper_barrier || ''
    this['Premium'] = typeof data.premium_amount === 'number' ? data.premium_amount : ''
    this['Premium Currency'] = data.premium_currency || ''
    this['Premium Date'] = data.premium_date ? dayjs(data.premium_date).format('DDMMYYYY') : ''
    this['Note'] = data.note || ''
    this['Fixing Date'] = data.fix_source_date ? dayjs(data.fix_source_date).format('DDMMYYYY') : ''
    this['Fixing Source'] = data.fixing_source || ''
    this['Payout Amount'] = data.payout_amount || ''
    this['Payout Currency'] = data.payout_currency || ''
    this['Timing'] = data.timing || ''
    this['Window Start'] = data.window_start ? dayjs(data.window_start).format('DDMMYYYY') : ''
    this['Window End'] = data.window_end ? dayjs(data.window_end).format('DDMMYYYY') : ''
    this['PB Mapping Value'] = data.prime_broker_mapping || ''
    this['Prime Broker'] = data.makor_prime_broker || ''
    this['Fee'] = data.fee || ''
    this['Dollar Notional'] = data.dollar_notional || ''
    this['Direction'] = data.direction
    this['Origin'] = data.origin
  }
}

export default Trade
